module.exports = __webpack_public_path__ + "img/travel5.a8a419b7.jpg";